import type { StorefrontUpsell } from '@xshop/shared';
import { sampleProducts } from './sampleCatalog';
import type { ElementProps } from './elementProps';

/** How much a sample offer takes off its product's price, so the preview shows a saving the way a real one does. */
const SAMPLE_DISCOUNT = 0.2;

// Builds the sample offer a preview shows: the theme's second sample product for the upsell, its third for the alternative.
export function sampleOffer(props: ElementProps, alternative: boolean): StorefrontUpsell | null {
  const slot = alternative ? 2 : 1;
  const samples = sampleProducts(props, slot + 1);
  const product = samples[slot] ?? samples[0];
  if (!product) return null;
  const price = Number(product.variants[0]?.price ?? 0);
  const unitPrice = Math.round(price * (1 - SAMPLE_DISCOUNT) * 100) / 100;
  return {
    id: `sample-offer-${slot}`, productTitle: product.title, variantTitle: null, imageUrl: product.images[0]?.src ?? null,
    title: alternative ? 'Before you go: a smaller treat' : 'Add this to your order',
    description: alternative ? 'A lighter way to finish your ritual, at a lower price.' : 'Shoppers who choose this often add it too, and it ships in the same parcel.',
    unitPrice, compareAtPrice: price, savings: Math.round((price - unitPrice) * 100) / 100
  };
}
